// @generated by protoc-gen-es v2.2.3
// @generated from file creativefabrica/content/v1/types.proto (package creativefabrica.content.v1, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";
import { file_creativefabrica_payments_v1_types } from "../../payments/v1/types_pb";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file creativefabrica/content/v1/types.proto.
 */
export const file_creativefabrica_content_v1_types = /*@__PURE__*/
  fileDesc("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", [file_creativefabrica_payments_v1_types, file_google_protobuf_timestamp]);

/**
 * Describes the message creativefabrica.content.v1.Description.
 * Use `create(DescriptionSchema)` to create a new message.
 */
export const DescriptionSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 0);

/**
 * Describes the message creativefabrica.content.v1.Asset.
 * Use `create(AssetSchema)` to create a new message.
 */
export const AssetSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 1);

/**
 * Describes the message creativefabrica.content.v1.AssetResolution.
 * Use `create(AssetResolutionSchema)` to create a new message.
 */
export const AssetResolutionSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 2);

/**
 * Describes the message creativefabrica.content.v1.ProductAccessTier.
 * Use `create(ProductAccessTierSchema)` to create a new message.
 */
export const ProductAccessTierSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 3);

/**
 * Describes the message creativefabrica.content.v1.Product.
 * Use `create(ProductSchema)` to create a new message.
 */
export const ProductSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 4);

/**
 * Describes the message creativefabrica.content.v1.ProductFeatures.
 * Use `create(ProductFeaturesSchema)` to create a new message.
 */
export const ProductFeaturesSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 5);

/**
 * Describes the message creativefabrica.content.v1.ProductSort.
 * Use `create(ProductSortSchema)` to create a new message.
 */
export const ProductSortSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 6);

/**
 * Describes the message creativefabrica.content.v1.ProductPricing.
 * Use `create(ProductPricingSchema)` to create a new message.
 */
export const ProductPricingSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 7);

/**
 * Describes the message creativefabrica.content.v1.ProductColors.
 * Use `create(ProductColorsSchema)` to create a new message.
 */
export const ProductColorsSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 8);

/**
 * Describes the message creativefabrica.content.v1.QuantizedHexColor.
 * Use `create(QuantizedHexColorSchema)` to create a new message.
 */
export const QuantizedHexColorSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 9);

/**
 * Describes the message creativefabrica.content.v1.QuantizedRGBColor.
 * Use `create(QuantizedRGBColorSchema)` to create a new message.
 */
export const QuantizedRGBColorSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 10);

/**
 * Describes the message creativefabrica.content.v1.RGBColor.
 * Use `create(RGBColorSchema)` to create a new message.
 */
export const RGBColorSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 11);

/**
 * Describes the message creativefabrica.content.v1.ProductFlags.
 * Use `create(ProductFlagsSchema)` to create a new message.
 */
export const ProductFlagsSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 12);

/**
 * Describes the message creativefabrica.content.v1.StringItems.
 * Use `create(StringItemsSchema)` to create a new message.
 */
export const StringItemsSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 13);

/**
 * Describes the message creativefabrica.content.v1.Seo.
 * Use `create(SeoSchema)` to create a new message.
 */
export const SeoSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 14);

/**
 * Describes the message creativefabrica.content.v1.ImageAnalysis.
 * Use `create(ImageAnalysisSchema)` to create a new message.
 */
export const ImageAnalysisSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 15);

/**
 * Describes the message creativefabrica.content.v1.Category.
 * Use `create(CategorySchema)` to create a new message.
 */
export const CategorySchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 16);

/**
 * Describes the message creativefabrica.content.v1.CategorySeo.
 * Use `create(CategorySeoSchema)` to create a new message.
 */
export const CategorySeoSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 17);

/**
 * Describes the message creativefabrica.content.v1.ActionResponse.
 * Use `create(ActionResponseSchema)` to create a new message.
 */
export const ActionResponseSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 18);

/**
 * Describes the message creativefabrica.content.v1.CurationMetadata.
 * Use `create(CurationMetadataSchema)` to create a new message.
 */
export const CurationMetadataSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 19);

/**
 * Describes the message creativefabrica.content.v1.Curation.
 * Use `create(CurationSchema)` to create a new message.
 */
export const CurationSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 20);

/**
 * Describes the message creativefabrica.content.v1.LinkBlockLink.
 * Use `create(LinkBlockLinkSchema)` to create a new message.
 */
export const LinkBlockLinkSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 21);

/**
 * Describes the message creativefabrica.content.v1.LinkBlock.
 * Use `create(LinkBlockSchema)` to create a new message.
 */
export const LinkBlockSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 22);

/**
 * Describes the message creativefabrica.content.v1.History.
 * Use `create(HistorySchema)` to create a new message.
 */
export const HistorySchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 23);

/**
 * Describes the message creativefabrica.content.v1.License.
 * Use `create(LicenseSchema)` to create a new message.
 */
export const LicenseSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 24);

/**
 * Describes the message creativefabrica.content.v1.Counter.
 * Use `create(CounterSchema)` to create a new message.
 */
export const CounterSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 25);

/**
 * Describes the message creativefabrica.content.v1.FavoriteList.
 * Use `create(FavoriteListSchema)` to create a new message.
 */
export const FavoriteListSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 26);

/**
 * Describes the message creativefabrica.content.v1.Favorite.
 * Use `create(FavoriteSchema)` to create a new message.
 */
export const FavoriteSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 27);

/**
 * Describes the message creativefabrica.content.v1.Review.
 * Use `create(ReviewSchema)` to create a new message.
 */
export const ReviewSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 28);

/**
 * Describes the message creativefabrica.content.v1.UserPublicInfo.
 * Use `create(UserPublicInfoSchema)` to create a new message.
 */
export const UserPublicInfoSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 29);

/**
 * Describes the message creativefabrica.content.v1.AssetCorrelation.
 * Use `create(AssetCorrelationSchema)` to create a new message.
 */
export const AssetCorrelationSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 30);

/**
 * Describes the message creativefabrica.content.v1.Pagination.
 * Use `create(PaginationSchema)` to create a new message.
 */
export const PaginationSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 31);

/**
 * Describes the message creativefabrica.content.v1.FieldProjection.
 * Use `create(FieldProjectionSchema)` to create a new message.
 */
export const FieldProjectionSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 32);

/**
 * Describes the message creativefabrica.content.v1.ListLicensesRequest.
 * Use `create(ListLicensesRequestSchema)` to create a new message.
 */
export const ListLicensesRequestSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 33);

/**
 * Describes the message creativefabrica.content.v1.ListLicensesResponse.
 * Use `create(ListLicensesResponseSchema)` to create a new message.
 */
export const ListLicensesResponseSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 34);

/**
 * Describes the message creativefabrica.content.v1.PaymentRequired.
 * Use `create(PaymentRequiredSchema)` to create a new message.
 */
export const PaymentRequiredSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 35);

/**
 * Describes the message creativefabrica.content.v1.PDPCategory.
 * Use `create(PDPCategorySchema)` to create a new message.
 */
export const PDPCategorySchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 36);

/**
 * Describes the message creativefabrica.content.v1.PDPLinkBlockLinks.
 * Use `create(PDPLinkBlockLinksSchema)` to create a new message.
 */
export const PDPLinkBlockLinksSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 37);

/**
 * Describes the message creativefabrica.content.v1.PDPLinkBlockSection.
 * Use `create(PDPLinkBlockSectionSchema)` to create a new message.
 */
export const PDPLinkBlockSectionSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 38);

/**
 * Describes the message creativefabrica.content.v1.PDPAsset.
 * Use `create(PDPAssetSchema)` to create a new message.
 */
export const PDPAssetSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 39);

/**
 * Describes the message creativefabrica.content.v1.PDPAlternativeSlug.
 * Use `create(PDPAlternativeSlugSchema)` to create a new message.
 */
export const PDPAlternativeSlugSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 40);

/**
 * Describes the message creativefabrica.content.v1.PDPFlags.
 * Use `create(PDPFlagsSchema)` to create a new message.
 */
export const PDPFlagsSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 41);

/**
 * Describes the message creativefabrica.content.v1.ProductSectionProduct.
 * Use `create(ProductSectionProductSchema)` to create a new message.
 */
export const ProductSectionProductSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_content_v1_types, 42);

/**
 * Describes the enum creativefabrica.content.v1.Source.
 */
export const SourceSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_content_v1_types, 0);

/**
 * @generated from enum creativefabrica.content.v1.Source
 */
export const Source = /*@__PURE__*/
  tsEnum(SourceSchema);

/**
 * Describes the enum creativefabrica.content.v1.ReadMode.
 */
export const ReadModeSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_content_v1_types, 1);

/**
 * *
 * API Call Read Mode
 *
 * @generated from enum creativefabrica.content.v1.ReadMode
 */
export const ReadMode = /*@__PURE__*/
  tsEnum(ReadModeSchema);

/**
 * Describes the enum creativefabrica.content.v1.ProductStatus.
 */
export const ProductStatusSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_content_v1_types, 2);

/**
 * *
 * Product Status
 *
 * @generated from enum creativefabrica.content.v1.ProductStatus
 */
export const ProductStatus = /*@__PURE__*/
  tsEnum(ProductStatusSchema);

/**
 * Describes the enum creativefabrica.content.v1.AssetType.
 */
export const AssetTypeSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_content_v1_types, 3);

/**
 * @generated from enum creativefabrica.content.v1.AssetType
 */
export const AssetType = /*@__PURE__*/
  tsEnum(AssetTypeSchema);

/**
 * Describes the enum creativefabrica.content.v1.AssetVariant.
 */
export const AssetVariantSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_content_v1_types, 4);

/**
 * @generated from enum creativefabrica.content.v1.AssetVariant
 */
export const AssetVariant = /*@__PURE__*/
  tsEnum(AssetVariantSchema);

/**
 * Describes the enum creativefabrica.content.v1.ProductSortField.
 */
export const ProductSortFieldSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_content_v1_types, 5);

/**
 * @generated from enum creativefabrica.content.v1.ProductSortField
 */
export const ProductSortField = /*@__PURE__*/
  tsEnum(ProductSortFieldSchema);

/**
 * Describes the enum creativefabrica.content.v1.ProductType.
 */
export const ProductTypeSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_content_v1_types, 6);

/**
 * @generated from enum creativefabrica.content.v1.ProductType
 */
export const ProductType = /*@__PURE__*/
  tsEnum(ProductTypeSchema);

/**
 * Describes the enum creativefabrica.content.v1.ProductFormat.
 */
export const ProductFormatSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_content_v1_types, 7);

/**
 * @generated from enum creativefabrica.content.v1.ProductFormat
 */
export const ProductFormat = /*@__PURE__*/
  tsEnum(ProductFormatSchema);

/**
 * Describes the enum creativefabrica.content.v1.CategoryType.
 */
export const CategoryTypeSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_content_v1_types, 8);

/**
 * @generated from enum creativefabrica.content.v1.CategoryType
 */
export const CategoryType = /*@__PURE__*/
  tsEnum(CategoryTypeSchema);

/**
 * Describes the enum creativefabrica.content.v1.Language.
 */
export const LanguageSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_content_v1_types, 9);

/**
 * *
 * Available Languages
 *
 * @generated from enum creativefabrica.content.v1.Language
 */
export const Language = /*@__PURE__*/
  tsEnum(LanguageSchema);

/**
 * Describes the enum creativefabrica.content.v1.CurationQueue.
 */
export const CurationQueueSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_content_v1_types, 10);

/**
 * *
 * Curation
 *
 * @generated from enum creativefabrica.content.v1.CurationQueue
 */
export const CurationQueue = /*@__PURE__*/
  tsEnum(CurationQueueSchema);

/**
 * Describes the enum creativefabrica.content.v1.CurationStatus.
 */
export const CurationStatusSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_content_v1_types, 11);

/**
 * @generated from enum creativefabrica.content.v1.CurationStatus
 */
export const CurationStatus = /*@__PURE__*/
  tsEnum(CurationStatusSchema);

/**
 * Describes the enum creativefabrica.content.v1.LinkBlockType.
 */
export const LinkBlockTypeSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_content_v1_types, 12);

/**
 * *
 * Link Block
 *
 * @generated from enum creativefabrica.content.v1.LinkBlockType
 */
export const LinkBlockType = /*@__PURE__*/
  tsEnum(LinkBlockTypeSchema);

/**
 * Describes the enum creativefabrica.content.v1.HistoryType.
 */
export const HistoryTypeSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_content_v1_types, 13);

/**
 * *
 * History
 *
 * @generated from enum creativefabrica.content.v1.HistoryType
 */
export const HistoryType = /*@__PURE__*/
  tsEnum(HistoryTypeSchema);

/**
 * Describes the enum creativefabrica.content.v1.CounterType.
 */
export const CounterTypeSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_content_v1_types, 14);

/**
 * *
 * Counter
 *
 * @generated from enum creativefabrica.content.v1.CounterType
 */
export const CounterType = /*@__PURE__*/
  tsEnum(CounterTypeSchema);

/**
 * Describes the enum creativefabrica.content.v1.PaginationType.
 */
export const PaginationTypeSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_content_v1_types, 15);

/**
 * *
 * Pagination
 *
 * @generated from enum creativefabrica.content.v1.PaginationType
 */
export const PaginationType = /*@__PURE__*/
  tsEnum(PaginationTypeSchema);

